import { createPrimarySelector } from '../../../utils/helpers';

export const selectBands = createPrimarySelector(state => state.entities.bands.general.entities);
